<template>
  <div class="login-container">
    <form @submit.prevent="handleLogin">
      <Alert type="danger" :messages="errors" />
      <div class="form-group custom-form-group">
        <label for="email">メールアドレス</label>
        <input
          type="email"
          v-model="username"
          class="form-control"
          name="email"
          v-validate="'required|email'"
          data-vv-as="メールアドレス"
          id="email"
        />
        <FieldError :message="formErrors.first('email')" />
      </div>
      <div class="form-group custom-form-group">
        <label for="password">パスワード</label>
        <div class="input-wrapper position-relative">
          <input
            :type="passwordType"
            id="password"
            v-model="password"
            class="form-control"
            data-vv-delay="0"
            v-validate="'required'"
            data-vv-as="パスワード"
            name="password"
          />
          <button
            class="btn-eye"
            type="button"
            @click="showPassword = !showPassword"
          >
            <i class="fa" :class="passwordEyeIcon" aria-hidden="true"></i>
          </button>
        </div>
        <FieldError :message="formErrors.first('password')" />
      </div>
      <div class="forgot-password mb-4">
        <router-link to="/forgot" class="forgot-link">
          パスワードをお忘れの場合
        </router-link>
      </div>
      <button
        class="submit-button"
        type="submit"
        :disabled="!validForm || processing"
      >
        ログイン
      </button>
    </form>
    <div class="terms mt-2">
      <router-link to="/agreement" class="forgot-link">
        法人向け利用規約
      </router-link>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import actions from '@/config/actions';
import { mapActions } from 'vuex';
import router from '../router';

export default {
  name: 'LoginForm',
  components: { FieldError, Alert },
  data() {
    return {
      username: '',
      password: '',
      processing: false,
      errors: [],
      showPassword: false,
    };
  },
  mounted() {
    const emailInput = document.getElementById('email');
    emailInput.focus();
  },
  computed: {
    payload() {
      return {
        username: this.username,
        password: this.password,
      };
    },
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordEyeIcon() {
      return this.showPassword ? 'fa-eye' : 'fa-eye-slash';
    },
    validForm() {
      const { email, password } = this.Vfields;
      if (email && password) {
        return (
          email.changed && password.changed && this.formErrors.count() === 0
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions([actions.auth.LOGIN, actions.auth.LOGGED_IN]),
    handleLogin(event) {
      event.preventDefault();
      this.processing = true;

      this.errors = [];
      this[actions.auth.LOGIN](this.payload)
        .then(({ data: token }) => {
          // console.log(token);
          if (token && token.twofa_required) {
            // console.log('twoFaRequired');
            return this.$router.push('/twofa-sent');
          }
          // return;
          this.errors = [];
          this[actions.auth.LOGGED_IN](token);
          this.$router.push('/pending-applicants');
        })
        .catch((error) => {
          console.log(error);
          const response = error.response;
          this.errors = [];
          if (response.status === 401)
            return this.errors.push(
              response.data == 'Unauthorized'
                ? response.data
                : response.data.data.message
                ? response.data.data.message
                : response.data.error_description
            );
          if (response.status === 402)
            return this.errors.push(
              'アカウントがブロックされています。管理者にお問い合わせ下さい。'
            );
          if (response.status === 403)
            return this.errors.push('IDまたはパスワードが間違っています。');
          if (response.status === 503)
            return this.errors.push(
              response.data.message
                ? response.data.message
                : response.data.error_description
            );
          return this.parseErrorResponse(response);
        })
        .then(() => {
          this.processing = false;
        });
    },
  },
};
</script>
<style scoped>
.login-container {
  max-width: 500px;
  width: 100%;
  /* text-align: center; */
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #617776;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin-bottom: 10px;
  background: #f8f9fa !important;
}

.submit-button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  background-color: #036d6c;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: auto;
}

.terms {
  float: right;
  font-weight: bold;
  color: red;
}

.position-relative {
  position: relative;
}

.btn-eye {
  top: 5%;
  right: 10px;
}

.custom-form-block .form-control.is-invalid {
  background: none;
}
.custom-form-block .form-control.is-valid {
  background: none;
}
</style>
